import { Box, Button, Card, CardContent, FormControlLabel, Grid, IconButton, Radio, TableCell, TableRow, Typography } from '@deere/fuel-react';
import { useOktaAuth } from '@okta/okta-react';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router';
import CustomAlert from '../../components/CustomAlert';
import LeftMenu from '../../components/LeftMenu';
import { ModalGeneric } from '../../components/ModalGeneric';
import { SVGIconDelete } from '../../components/SVGIcon';
import SurveyTitle from '../../components/SurveyTitle';
import ButtonSectionFactory from '../../components/buttons/ButtonSectionFactory';
import { deleteCOOResponseByResponseId, getCOOResponseById, getCOOResponsesByAssignment } from '../../services/coo.service';
import { COO_RESPONSE_STATUSES, SCBM_STATES_CAMPAIGN } from '../../utils/surveyLiterals';
import { COO_DISCLAIMER_URL } from '../../utils/constEnvVariables';
import { dateConvert } from '../../utils/utils';
import COOSectionPage from './COOSectionPage';
import { Alert } from "@deere/ux.uxframe-react";

export const COOSurveyPage = ({ survey, campaignAssigned, setSurvey, literals, setLiterals}) => {
    const history = useHistory();
    const sections = survey.sections;
    let sectionsTitles = [...sections.map((section, index) => section.description)]
    const sectionsRef = useRef([new Array(sectionsTitles.length)]);
    const [validated, setValidated] = useState(false)
    let questionsToValidate
    const [actLink, setActLink] = useState(new Array(sectionsTitles.length).fill(""));
    const { authState } = useOktaAuth();
    const [errorCard, setErrorCard] = useState([]);
    const [successMessage, setSuccessMessage] = useState(undefined);
    const [cooResponses, setCOOResponses] = useState(undefined);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);
    const [editedPartCountries, setEditedPartCountries] = useState([]);
    const { t } = useTranslation();
    const form = document.forms.cooForm;

    const [cooData, setCooData] = useState({
        suppliers: [],
        answers: [],
        assignments: [],
        errors: [],
        country: null,
        parts: [],
        campaignId: null,
        cooResponseSelected: null,
        responseName: null
    })

    const [showValidationModal, setShowValidationModal] = useState(false);
    const [opcTodelete, setOpcTodelete] = useState(null);
    const [opcSelected, setOpcSelected] = useState(null);
    const [cooResponseSelected, setCOOResponseSelected] = useState(undefined);
    const [deleteResponseMessage, setdeleteResponseMessage] = useState(null);

    function clearErrors() {
        setValidated(false);
        setErrorCard([]);
        setSuccessMessage(undefined);
    }

    function review(responseId,newCooData) {
        // TODO - review page is yet to be done
        history.push({
            pathname: '/coo/review',
            state: {
                previous: '/coo',
                assignmentId: campaignAssigned.assignments[0].id,
                responseId: responseId,
                survey: survey,
                cooData: newCooData
            }
        })
    }

    const resetForm = () => {
        setEditedPartCountries([])
        setSelectionModel([]);
        setOpcSelected(null);
        setCooData({
            suppliers: [],
            answers: [],
            assignments: [],
            errors: [],
            country: null,
            parts: [],
            campaignId: null,
            cooResponseSelected: null,
            responseName: null
        })
    }

    const deleteResponse = () => {
        try {
            deleteCOOResponseByResponseId(opcTodelete, authState.accessToken.accessToken).then((response) => {
                if (response && response.numberResponsesDeleted && response.numberResponsesDeleted > 0) {
                    getCOOResponsesByAssignment(campaignAssigned.assignments[0].id, authState.accessToken.accessToken).then(response => {
                        if (response) {
                            setCOOResponses(response);
                        }
                    });
                    resetForm();
                    setSuccessMessage(t('coo_msg_success_delete'));
                } else {
                    setErrorCard(t('coo_msg_response_not_found'));
                    window.scrollTo(0, 0);
                }
                setShowValidationModal(false);
            })
        } catch (error) {
            console.log(error);
            setShowValidationModal(false);
            setErrorCard(t('coo_msg_response_not_found'));
            window.scrollTo(0, 0);
        }
    }

    function setResponseSelected(e, response, goToReviewPage) {
        resetForm();
        getCOOResponseById(response.id, authState.accessToken.accessToken)
            .then((res) => {
                setOpcSelected(e.target.value);
                setCOOResponseSelected(response);
                res.cooResponseSelected = response;
                let suppliers = res.assignments && res.assignments.length > 0 ? res.assignments.map(it => it.supplierNumber) : [];
                const newCooData = { ...res };
                newCooData.suppliers = suppliers;
                setCooData(newCooData);
                if(goToReviewPage){
                    review(response.id,newCooData);
                }
            }).catch(error => {
                console.log(error)
                setErrorCard(t('tps_msg_response_not_found'));
            })
    }


    function getTableRows(data) {
        if (data) {
            return data.map((row, index) =>

                <TableRow key={index}>
                    <TableCell>
                        <FormControlLabel
                            control={<Radio name="responseSelected" id='responseSelected' value={row.id} checked={cooData.id === row.id ? true : false} />}
                            label=""
                            onChange={(e) => setResponseSelected(e, row, false)}
                        />
                    </TableCell>
                    <TableCell>
                        {
                            row.status === COO_RESPONSE_STATUSES.SUBMITTED ?
                                <Button variant="text" onClick={(e) => {setResponseSelected(e, row, true)}} >{row.responseName}</Button>
                                : row.responseName
                        }
                    </TableCell>
                    <TableCell align="right">{row.numberOfParts}</TableCell>
                    <TableCell align="right">{dateConvert(row.lastUpdatedTs)}</TableCell>
                    <TableCell align="right">{row.updatedBy}</TableCell>
                    <TableCell align="right">{row.status}</TableCell>
                    <TableCell align="right">
                        <IconButton aria-label="delete" onClick={e => { setOpcTodelete(row.id); buildModalMessage(row); setShowValidationModal(true) }} disabled={disableDeleteIcon()}>
                            <SVGIconDelete />
                        </IconButton>
                    </TableCell>
                </TableRow>)
        } else {
            return null;
        }
    }

    function disableDeleteIcon(){
        return campaignAssigned && campaignAssigned.status === SCBM_STATES_CAMPAIGN.CLOSED ?  true : false;
    }

    function getLastResponse(data) {
        if (data) {
            const tmpArray = [...data];
            tmpArray.sort(function (a, b) {
                return new Date(b.lastUpdatedTs) - new Date(a.lastUpdatedTs);
            });
            return tmpArray[0];
        } else {
            return null;
        }
    }

    useEffect(() => {
        const assigmentId = campaignAssigned && campaignAssigned.assignments[0] ? campaignAssigned.assignments[0].id : null;
        if (assigmentId) {
            getCOOResponsesByAssignment(assigmentId, authState.accessToken.accessToken).then(response => {
                if (response) {
                    setCOOResponses(response);
                }
            });
        }
    }, [authState.accessToken.accessToken, campaignAssigned])

    const buildModalMessage = (response) => {
        const { assignments } = campaignAssigned;
        const supplierNumber = assignments.filter(assignment => assignment.id === response.campaignAssignmentId);
        const message = `${t('coo_msg_delete_response')}\n ${t('coo_msg_delete_response_number', { responseName: response.responseName ? response.responseName : "", supplierNumber: supplierNumber[0].supplierNumber })}`
        setdeleteResponseMessage(message);
    }

    const pushAnswer = (questionId, answer, isCountry, answersToDelete) => {

        let finalContextAnswers = cooData.answers ? [...cooData.answers] : [];
        let childQuestions = [];

        const ans = {
            questionId,
            answer: answer
        }

        if (answersToDelete && answersToDelete.length > 0) {
            childQuestions = answersToDelete.filter(child => child.idQuestionDepends === questionId);
        }

        if (isCountry && cooData.country !== ans.answer && answersToDelete && answersToDelete.length > 0) {
            finalContextAnswers = finalContextAnswers.filter(ans => !answersToDelete.some(answerDelete => ans.questionId === answerDelete.id));
        }

        if (childQuestions && childQuestions.length > 0) {
            finalContextAnswers = finalContextAnswers.filter(ans => !childQuestions.some(childQ => ans.questionId === childQ.id));
        }


        const tmpId = finalContextAnswers ? finalContextAnswers.findIndex(a => parseInt(a.questionId) === parseInt(questionId)) : -1;
        if (tmpId >= 0) {
            if (ans && ans.answer.length > 0) {
                finalContextAnswers[tmpId] = ans;
                setCooData({
                    ...cooData,
                    country: isCountry ? answer : cooData.country,
                    answers: [...finalContextAnswers]
                })
            } else {
                popAnswer(questionId)
            }
        } else {
            setCooData({
                ...cooData,
                answers: Array.isArray(finalContextAnswers) ? [...finalContextAnswers, ans] : [ans],
                country: isCountry ? answer : cooData.country
            });
        }
    };

    const updateSuppliersArray = (array) => {
        if (Array.isArray(array)) {
            setCooData({
                ...cooData,
                suppliers: [...array.map(i=>i.supplierNumber)],
                assignments:array
            });
        }
    }

    const pushResponseName = (newResponseName) => {
        setCooData({
            ...cooData,
            responseName: newResponseName
        })
    }

    const updatePartsArray = (partsArray) => {
        let tempArr = [];
        partsArray.forEach((part) => {
          part.country.forEach((c) => tempArr.push({ 
            id: part.id, 
            country: c,
            supplierNumber:part.supplierNumber,
            deerePartNumber:part.deerePartNumber,
            deerePartDesc:part.deerePartDesc,
            unitCd: part.unitCd,
          }));
        });
        setCooData({
            ...cooData,
            parts: tempArr
        })
    }

    const popAnswer = (questionId) => {
        const newAns = Array.isArray(cooData.answers) ? cooData.answers.filter(a => a.questionId !== questionId) : [cooData.answers];
        setCooData({
            ...cooData,
            answers: newAns
        })
    }

    const showErrorCard = <>
        <Card className='p-2 mb-2 bg-danger'>
            <CardContent className="uxf-card-body-table">
                <Typography className='pb-3 text-white'>
                    {
                        !(errorCard && errorCard.length > 0 && errorCard[0].includes('saving')) ? t('lbl_error_survey_validation') : ''
                    }
                </Typography>
                {
                    errorCard.map((error, index) =>
                        <div key={index}>
                            <li className='text-white'>{error}</li>
                        </div>
                    )
                }
            </CardContent>
        </Card>
        <br />
    </>
    return (<><Grid container>
        <Grid item xs={12}>
            <SurveyTitle survey={survey} assignment={campaignAssigned.assignments[0]} latestResponse={getLastResponse(cooResponses)} endDate={campaignAssigned.endDate} />
        </Grid>
        <Grid item xs={12} md={2.5}>
            <LeftMenu actLink={actLink} survey={survey} isNewFrameWork></LeftMenu>
        </Grid>
        <Grid item xs={12} md={9.5}>
            <Box>
                {
                    errorCard.length > 0 ? showErrorCard : null
                }
                {
                    successMessage ?
                        <CustomAlert accessibilityLabel='success' variant='success' title={successMessage} />
                        : null
                }
            </Box>
            <Box>
                <Alert accessibilityLabel="warning:" variant="warning">
                    <h5 className="uxf-alert-title" style={{textAlign:"justify", textAlignLast:"left"}}>
                        {t('coo_disclaimer_msg')}
                    </h5>
                    <h5 className="uxf-alert-title">
                        <a href={COO_DISCLAIMER_URL} target="_blank">{COO_DISCLAIMER_URL}</a>
                    </h5>
                </Alert>
            </Box>
            <form noValidate validated={validated} id='cooForm'>
                {
                    sections.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).map((section, index) =>
                        <div key={index} ref={el => sectionsRef.current[index] = el}>
                            <COOSectionPage
                                cooData={cooData}
                                section={section}
                                survey={survey}
                                questionsToValidate={questionsToValidate}
                                campaign={campaignAssigned}
                                cooResponses={getTableRows(cooResponses)}
                                isSubmit={isSubmitted}
                                setIsSubmitted={setIsSubmitted}
                                resetForm={resetForm}
                                opcSelected={opcSelected}
                                pushAnswer={pushAnswer}
                                popAnswer={popAnswer}
                                pushResponseName={pushResponseName}
                                updatePartsArray={updatePartsArray}
                                updateSuppliersArray={updateSuppliersArray}
                                selectionModel={selectionModel}
                                setSelectionModel={setSelectionModel}
                                editedPartCountries={editedPartCountries}
                                setEditedPartCountries={setEditedPartCountries}
                            />
                        </div>
                    )
                }
                <ButtonSectionFactory campaign={campaignAssigned} clearFunction={clearErrors} survey={survey} code={survey.code} setSurvey={setSurvey} setLiterals={setLiterals}
                    setErrorCard={setErrorCard} setSuccessMessage={setSuccessMessage} setCOOResponseSelected={setCOOResponseSelected} cooResponseSelected={cooResponseSelected} isSubmit={isSubmitted} setIsSubmitted={setIsSubmitted} errorCard={errorCard}
                    setValidated={setValidated} sections={sections} cooForm={form} setCOOResponses={setCOOResponses} opcSelected={opcSelected} cooData={cooData} resetForm={resetForm}/>
            </form>
        </Grid>
    </Grid>
        <ModalGeneric showModal={showValidationModal} setShowModal={setShowValidationModal} labelBtnPrimary={t('t2_remove')} labelBtnSecondary={t('btn_cancel')} handleSubmit={deleteResponse} msgModal={deleteResponseMessage} titleModal={t('t2_remove')} />
    </>
    )
}
